import { render, staticRenderFns } from "./ItemAsientoVuelta.vue?vue&type=template&id=77847554&"
import script from "./ItemAsientoVuelta.vue?vue&type=script&lang=js&"
export * from "./ItemAsientoVuelta.vue?vue&type=script&lang=js&"
import style0 from "./ItemAsientoVuelta.vue?vue&type=style&index=0&id=77847554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports